/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface VendSecretResponseContent
 */
export interface VendSecretResponseContent {
    /**
     * CivicTech-generated identifier for an API key stored in our experience's
experience's secret store. Up to two API Gateway API keys could correspond
to a secret to support rotation. I'm not sure yet if having a separate
secret ID is preferable to just using the experience ID itself. So we
may remove this later. My thinking now though is that we may eventually
have the prod account communicate with the gamma account to get a gamma
API key but that's much longer term. In that long-term scenario, it'd
help to have separate secret IDs.
     * @type {string}
     * @memberof VendSecretResponseContent
     */
    secretId: string;
}


/**
 * Check if a given object implements the VendSecretResponseContent interface.
 */
export function instanceOfVendSecretResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "secretId" in value;
    return isInstance;
}

export function VendSecretResponseContentFromJSON(json: any): VendSecretResponseContent {
    return VendSecretResponseContentFromJSONTyped(json, false);
}

export function VendSecretResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendSecretResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'secretId': json['secretId'],
    };
}

export function VendSecretResponseContentToJSON(value?: VendSecretResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'secretId': value.secretId,
    };
}

